<template>
    <div class="progress" :class="classes">
        <i :class="classesIcon" />
        <span class="progress-label">
            <span class="title">{{ labelText2 }}:</span> {{ labelText }}
        </span>

        <div class="progress-bar" :style="style" />
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Number,
            default: null
        },

        max: {
            type: Number,
            default: null
        },

        vertical: {
            type: Boolean,
            default: false
        },

        type: {
            type: String,
            default: 'spirals'
        }
    },

    computed: {
        percent() {
            return (this.loading > 0 && this.max > 0) ? Math.round(this.loading / this.max * 100) : 0
        },

        style() {
            return {
                '--percent': `${this.percent}%`
            }
        },

        classes() {
            return {
                'progress-vertical': this.vertical,
                'progress-horizontal': !this.vertical,
                'progress-success': this.percent >= 75,
                'progress-warning': this.percent > 10 && this.percent < 75,
                'progress-danger': this.percent <= 10
            }
        },

        labelText() {
            return this.type === 'components' ? `${this.percent}%` : `${this.loading}/${this.max}`
        },

        labelText2() {
            return this.type === 'components' ? 'Ингредиенты' : 'Спирали'
        },

        classesIcon() {
            return {
                'tlm-icon-spiral': this.type === 'spirals',
                'tlm-icon-coffee-togo': this.type === 'components'
            }
        }
    }
}
</script>
